<template>
  <div
    v-if="Object.keys(reportData).length"
    style="padding: 1rem;"
  >
    <div class="ui grid">
      <div class="six wide column" style="padding: 1rem 1rem 0;">
        <img
          class
          src="@/assets/images/logo_hmb.png"
          style="float: left; width: 50px; margin-right: 1rem;"
        >
        <h3 class="ui header" style="margin-top: 8px;">
          {{ reportData.title }}
          <div class="sub header" style="font-size: 0.8rem;">MARKET SUMMARY - MAIN KPIs</div>
        </h3>
      </div>
      <div class="center aligned four wide column"></div>
      <div class="right aligned six wide column" style="padding: 1rem 1rem 0;">
        <img src="@/assets/images/logo_neocom.svg" alt style>
        <br>
        <report-legend currentDayText="Print Date"/>
      </div>
    </div>
    <div class="ui grid">
      <div
        class="nine wide column"
        :style="{ height: printMode ? '430px' : 'auto', minHeight: '100%' }"
      >
        <h5 class="ui header">1 - GEOGRAPHIC LOCATION</h5>
        <div class="ui grid" :style="{ minHeight: '100%', width: printMode ? '600px' : 'auto' }">
          <div class="twelve wide column" style="padding: 1rem 0 1rem 1rem">
            <div ref="worldMapContainer1" class="map-1"></div>
          </div>
          <div class="four wide column" style="padding: 1rem 1rem 1rem 0">
            <div ref="worldMapContainer2" class="map-2"></div>
            <div ref="worldMapContainer3" class="map-3"></div>
          </div>
        </div>
      </div>
      <div class="seven wide column">
        <h5 class="ui header">3 - VOLUME (DONE & FORECAST)</h5>
        <kendo-chart
          type="column"
          format="{0:n0}"
          :printSize="{ height: 220, width: 460 }"
          :printMode="printMode"
          :fontSize="12"
          :colors="[ '#2185D0' ]"
          :category="{ field: 'ano' }"
          :series="[
          { axis: 'firstAxis', name: 'Industry Registration', field: 'ind_reg_tot', color: getChartIndustryColor, border: { color: getChartIndustryBorderColor, dashType: getChartBorderType, width: getChartBorderWidth }, labels: { visible: true, color: '#212121', position: 'insideBase', rotation: -90 }, markers: { visible: true, background: '#eee', border: { color: getChartIndustryBorderColor }, type: 'square' } },
          { axis: 'secondAxis', name: brand + ' Registration', field: 'cli_ret_tot', color: getChartBrandColor, border: { color: getChartBrandBorderColor, dashType: getChartBorderType, width: getChartBorderWidth }, labels: { visible: true, color: '#212121', position: 'insideBase', rotation: -90 }, markers: { visible: true, background: '#03a9f4', border: { color: getChartBrandBorderColor }, type: 'square' } },
          { axis: 'thirdAxis', type: 'line', name: brand + ' Market Share', field: 'mkt_area', color: '#212121', border: { color: '#212121' }, labels: { visible: true, position: 'above', format: '{0:p2}' }, markers: { visible: true, background: '#212121', border: { color: '#212121' }, type: 'circle', typeOverlap: 'line', size: 13 } }
        ]"
          :valueAxis="[
          { name: 'firstAxis', visible: true, labels: { visible: false }, majorGridLines: { visible: true } },
          { name: 'secondAxis', visible: false, labels: { visible: false }, majorGridLines: { visible: true } },
          { name: 'thirdAxis', visible: false, labels: { visible: false }, majorGridLines: { visible: true }, max: getMaxFromProperties(reportData.doneAndForecast, ['mkt_area'], 1.25, false) }
        ]"
          :skipButtons="true"
          :height="180"
          :chartArea="{ margin: 5 }"
          :label="{ visible: true }"
          :legend="{ type: 'marker', fontSize: 11, spacing: printMode ? 2 : 10 }"
          :dataSource="reportData.doneAndForecast"
        />
        <table class="ui celled basic small compact table" v-if="Object.keys(reportData.doneAndForecastTable).length">
          <thead>
            <tr>
              <th
                class="ui center aligned inverted small header"
                style="padding: 2px; background-color: #757575;"
                rowspan="2"
              >{{ reportData.title }}</th>
              <th
                class="ui center aligned inverted small header"
                :colspan="reportData.doneAndForecastTable[0].length"
                style="padding: 2px; background-color: #757575;"
              >DONE</th>
              <th
                class="ui center aligned inverted small header"
                :colspan="reportData.doneAndForecastTable[1].length"
                style="padding: 2px; background-color: #616161;"
              >ESTIMATE</th>
            </tr>
            <tr>
              <th
                class="ui center aligned inverted small header"
                :key="`k0${index}`"
                v-for="(item, index) in reportData.doneAndForecastTable[0]"
                style="padding: 2px; background-color: #757575;"
              >{{ item.ano }}</th>
              <th
                class="ui center aligned inverted small header"
                :key="`k1${index}`"
                v-for="(item, index) in reportData.doneAndForecastTable[1]"
                style="padding: 2px; background-color: #616161;"
              >{{ item.ano }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="row in doneAndForecastSimpleConfig">
              <tr :key="`k2${row.key}`">
                <td
                  :class="['ui small', row.color === '#03a9f4' ? 'inverted' : '','header']"
                  :style="{ backgroundColor: row.color }"
                >{{ row.title }}</td>
                <td
                  class="ui center aligned small header"
                  :key="`k3${index}`"
                  v-for="(item, index) in reportData.doneAndForecastTable[0]"
                  style="font-weight: 400;"
                >{{ numeral(row.key === 'pais' ? item[row.key] / 1000 : item[row.key]).format( row.key === 'mkt_area' ? '0,0.0%' : '0,0') }}</td>
                <td
                  class="ui center aligned small header"
                  :key="`k4${index}`"
                  v-for="(item, index) in reportData.doneAndForecastTable[1]"
                  :style="{ padding: '2px', backgroundColor: row.title.indexOf(brand) > -1 ? '#81d4fa' : '#eee' }"
                >{{ numeral(row.key === 'pais' ? item[row.key] / 1000 : item[row.key]).format( row.key === 'mkt_area' ? '0,0.0%' : '0,0') }}</td>
              </tr>
              <tr v-if="row.key === 'pais'" :key="`k5${row.key}`">
                <td
                  :colspan="reportData.doneAndForecast.length + 1"
                  class="ui center aligned small header"
                  style=" padding: 2px 6px;"
                >REGISTRATION AND SALES IN {{ getAreaTypeTextAlt(dataQuery.type.value) }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="ui grid">
      <div class="eight wide column">
        <h5 class="ui header">2 - INDUSTRY BENCHMARKING</h5>
        <table class="ui celled basic small compact table">
          <thead>
            <tr>
              <th rowspan="2" style="padding: 2px; background-color: #f5f5f5;"></th>
              <th
                class="ui center aligned inverted small header"
                style="padding: 2px; background-color: #757575;"
              >{{ this.yearSelect }}</th>
              <th
                class="ui center aligned inverted small header"
                :colspan="reportData.industryBenchmarking.length"
                style="padding: 2px; background-color: #757575;"
              >{{ reportData.title }}</th>
            </tr>
            <tr>
              <th
                class="ui center aligned inverted small header"
                style="padding: 2px; background-color: #757575;"
              >BRAND</th>
              <th
                :class="['ui center aligned', 'inverted', 'small header']"
                :key="`k6${index}`"
                v-for="(item, index) in reportData.industryBenchmarking"
                :style="{ padding: '2px', backgroundColor: item.bandeira === 'TOTAL' ? '#616161' : '#757575' }"
              >{{ item.bandeira }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="row in industryBenchmarkingConfig">
              <tr :key="`k7${row.key}`">
                <td
                  class="ui center aligned small header"
                  :style="{ backgroundColor: '#f5f5f5' }"
                >{{ row.aux }}</td>
                <td class="ui small header">{{ row.title }}</td>
                <td
                  :class="['ui center aligned', index === 0 ? 'inverted' : '', 'small header']"
                  :key="`k8${index}`"
                  v-for="(item, index) in reportData.industryBenchmarking"
                  :style="{ backgroundColor: item.bandeira === 'TOTAL' ? '#bdbdbd' : index === 0 ? '#03a9f4' : '', fontWeight: item.bandeira === 'TOTAL' ? '700' : index === 0 ? '700' : '400' }"
                >{{ numeral(item[row.key]).format( row.key === 'market_share' ? '0,0.0%' : '0,0') }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="four wide column">
        <h5 class="ui header">4 - CURRENT SITUATION</h5>
        <table class="ui celled basic small compact table">
          <thead>
            <tr>
              <th
                class="ui center aligned inverted small header"
                style="padding: 2px; background-color: #757575;"
                rowspan="2"
              >{{ reportData.title }}</th>
              <th
                class="ui center aligned inverted small header"
                style="padding: 2px; background-color: #757575;"
              >DONE</th>
            </tr>
            <tr>
              <th
                class="ui center aligned inverted small header"
                style="padding: 2px; background-color: #616161;"
              >
                {{reportData.actualMarket[0]['periodo']}}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="row in doneAndForecastSimpleConfig">
              <tr :key="`k22${row.key}`">
                <td
                  :class="['ui small', row.color === '#03a9f4' ? 'inverted' : '','header']"
                  :style="{ backgroundColor: row.color }"
                >{{ row.title }}</td>
                <td
                  class="ui center aligned small header"
                  style="font-weight: 400;"
                >{{ numeral(row.key === 'pais' ? reportData.actualMarket[0][row.key] / 1000 : reportData.actualMarket[0][row.key]).format( row.key === 'mkt_area' ? '0,0.0%' : '0,0') }}</td>
              </tr>
              <tr v-if="row.key === 'pais'" :key="`k23${row.key}`">
                <td
                  colspan="2"
                  class="ui center aligned small header"
                  style=" padding: 2px 6px;"
                >REGISTRATION AND SALES IN {{ getAreaTypeTextAlt(dataQuery.type.value) }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="four wide column">
        <h5 class="ui header">5 - MARKET SHARE REFERENCES</h5>
        <table class="ui celled basic small compact table">
          <thead>
            <tr>
              <th
                class="ui center aligned inverted small header"
                style="padding: 2px; background-color: #757575;"
              >MARKET-SHARE TOTAL</th>
              <th
                class="ui center aligned inverted small header"
                style="padding: 2px; background-color: #757575;">
                {{reportData.marketShareReference[0]['periodo']}}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in reportData.marketShareReference">
              <tr :key="`k9${index}`">
                <td
                  class="ui small header"
                  :style="{ backgroundColor: index === 0 ? '#bdbdbd' : '' }"
                >{{ item.area }}</td>
                <td
                  class="ui center aligned small header"
                  :style="{ backgroundColor: index === 0 ? '#bdbdbd' : '' }"
                >{{ numeral(item.mkt_area).format('0,0.0%') }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="ui grid page-break">
      <div class="twelve wide column" v-if="Object.keys(reportData.doneAndForecastTable).length">
        <h5 class="ui header">BACKUP INFORMATION</h5>
        <table class="ui celled basic small compact table">
          <thead>
            <tr>
              <th rowspan="2" style="padding: 2px; background-color: #f5f5f5;"></th>
              <th
                class="ui center aligned inverted small header"
                style="padding: 2px; background-color: #757575;"
                rowspan="2"
              >{{ reportData.title }}</th>
              <th
                class="ui center aligned inverted small header"
                :colspan="reportData.doneAndForecastTable[0].length"
                style="padding: 2px; background-color: #757575;"
              >DONE</th>
              <th
                class="ui center aligned inverted small header"
                :colspan="reportData.doneAndForecastTable[1].length"
                style="padding: 2px; background-color: #616161;"
              >ESTIMATE</th>
            </tr>
            <tr>
              <th
                class="ui center aligned inverted small header"
                :key="`k13${index}`"
                v-for="(item, index) in reportData.doneAndForecastTable[0]"
                style="padding: 2px; background-color: #757575;"
              >{{ item.ano }}</th>
              <th
                class="ui center aligned inverted small header"
                :key="`k14${index}`"
                v-for="(item, index) in reportData.doneAndForecastTable[1]"
                style="padding: 2px; background-color: #616161;"
              >{{ item.ano }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="row in doneAndForecastConfig">
              <tr :key="`k15${row.key}`">
                <td
                  class="ui center aligned small header"
                  :style="{ backgroundColor: row.auxColor }"
                >{{ row.aux }}</td>
                <td
                  :class="['ui small', row.color === '#03a9f4' ? 'inverted' : '','header']"
                  :style="{ fontWeight: row.bold ? '700' : '400', backgroundColor: row.color }"
                >{{ row.title }}</td>
                <td
                  class="ui center aligned small header"
                  :key="`k16${index}`"
                  v-for="(item, index) in reportData.doneAndForecastTable[0]"
                  :style="{ fontWeight: row.bold ? '700' : '400' }"
                >{{ numeral(row.key === 'pais' ? item[row.key] / 1000 : item[row.key]) .format( ['mkt_area', 'inv_exp'].some(k => row.key === k) ? '0,0.0%' : '0,0') }}</td>
                <td
                  class="ui center aligned small header"
                  :key="`k17${index}`"
                  v-for="(item, index) in reportData.doneAndForecastTable[1]"
                  :style="{fontWeight: row.bold ? '700' : '400', backgroundColor: row.title.indexOf(brand) > -1 ? '#81d4fa' : '#eee' }"
                >{{ numeral(row.key === 'pais' ? item[row.key] / 1000 : item[row.key]) .format( ['mkt_area', 'inv_exp'].some(k => row.key === k) ? '0,0.0%' : '0,0') }}</td>
              </tr>
              <tr v-if="row.key === 'pais'" :key="`k18${row.key}`">
                <td
                  :colspan="reportData.doneAndForecast.length + 2"
                  class="ui center aligned small header"
                  style=" padding: 2px 6px;"
                >REGISTRATION IN {{ getAreaTypeTextAlt(dataQuery.type.value) }}</td>
              </tr>
              <tr v-if="row.key === 'mkt_area'" :key="`k19${row.key}`">
                <td
                  :colspan="reportData.doneAndForecast.length + 2"
                  class="ui center aligned small header"
                  style=" padding: 2px 6px;"
                >SALES IN {{ getAreaTypeTextAlt(dataQuery.type.value) }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="four wide column">
        <h5 class="ui header">COMPARISION BASKET (TOP 10)</h5>
        <table class="ui celled basic small compact table">
          <thead>
              <tr>
                <th
                class="ui center aligned inverted small header"
                style="padding: 2px; background-color: #616161;"
                colspan="3"
                >{{reportData.comparissonBasket[0]['periodo']}}</th>
              </tr>
            <tr>
              <th
                class="ui center aligned inverted small header"
                style="padding: 2px; background-color: #757575;"
              >RANKING</th>
              <th
                class="ui center aligned inverted small header"
                style="padding: 2px; background-color: #757575;"
              >CITY / UF</th>
              <th
                class="ui center aligned inverted small header"
                style="padding: 2px; background-color: #757575;"
              >MARKET-SHARE TOTAL</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="`k20${index}`" v-for="(item, index) in reportData.comparissonBasket">
              <td class="ui center aligned small header" style="font-weight: 400;">{{ item.id }}</td>
              <td class="ui small header">{{ item.cidade }}</td>
              <td
                class="ui center aligned small header"
              >{{ numeral(item.mkt_area).format('0,0.0%') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="ui grid">
      <div class="twelve wide column">
        <span>Limitations of use for this report:</span>
        <span>The market share projections automatically made for future periods in this report are based on parameters selected by the user.</span>
        <span>And, therefore, that the parameters are not represented as future waves more rational or of greater probability of occurrence in the analyzed market.</span>
        <span>Therefore, the projections for future periods presented in this report should be used only as an initial reference on the markets and should be confirmed by non-automatic studies that undergo technical evaluations and use methodologies appropriate for each case and especially for markets of greater size.</span>
        <span>Sales volumes represents where the vehicles were sold (outlet place)</span>
        <span>Registration volumes represents where the vehicles were registered (customer place)</span>
      </div>
      <div class="four wide column">
        <span>Source: Sales & Registration Data</span>
        <span>Done: ANFAVEA / FENABRAVE / DENATRAN</span>
        <span>Estimate: NEOCOM</span>
      </div>
    </div>
  </div>
  <report-unavailable v-else/>
</template>

<script>
import * as turf from '@turf/turf';
import * as d3 from 'd3';
import _ from 'lodash';
import * as topojson from 'topojson-client';
import { mapGetters } from 'vuex';

import KendoChart from '@/components/kendo-chart/kendo-chart';
import KendoGrid from '@/components/kendo-grid/kendo-grid';
import ReportLegend from '@/modules/neodash/components/report-legend/report-legend';
import ReportUnavailable from '@/modules/neodash/components/report-unavailable/report-unavailable';

import { httpMixin, i18nMixin, momentMixin, numeralMixin, stringMixin } from '@/modules/neodash/mixins';

import { CONFIG } from '@/config';
import { REPORT_GET_REPORTS } from '@/modules/neodash/store/modules/report/types';
import { PRINT_GET_PRINT_MODE } from '@/store/modules/print/types';
import {ContextEnum} from '@/enums/context.enum';
import {traceLogAccess} from '@/services';

export default {
  props: {
    dataQuery: { type: Object, showMarketSummary: Boolean, required: true }
  },

  data() {
    return {
      reportData: {},
      brand: 'HMB',
      mapCenter: {
        lat: -15.0,
        lng: -52.0
      },
      shapes: {
        area: undefined,
        stores: undefined,
        sales: undefined
      },
      bigMarkets: [
        2032793, // São Paulo, SP
        2032196, // Rio de Janeiro, RJ
        2034444, // Brasília, DF
        2032055, // Belo Horizonte, MG
        2032944, // Curitiba, PR
        2031450, // Recife, PE
        2033958, // Porto Alegre, RS
        2031964, // Salvador, BA
        2030787, // Fortaleza, CE
        2030787, // Fortaleza, CE
        2034302, // Goiânia, GO
        2030744, // Campinas, SP
        2747826, // Sao Paulo, Hyundai
        2747804, // Rio de Janeiro, Hyundai
        2747669, // Brasília, Hyundai
        2747662, // Belo Horizonte, Hyundai
        2747696, // Curitiba, Hyundai
        2747798, // Recife, Hyundai
        2747794, // Porto Alegre, Hyundai
        2747810, // Salvador, Hyundai
        2747705, // Fortaleza, Hyundai
        2747709, // Goiânia, Hyundai
        2747675 // Campinas, Hyundai
      ],
      ignoredAreas: [],
      worldMaps: [],
      yearSelect: ''
    };
  },

  computed: {
    ...mapGetters({
      report: REPORT_GET_REPORTS,
      printMode: PRINT_GET_PRINT_MODE
    }),

    doneAndForecastSimpleConfig() {
      return [
        {
          key: 'pais',
          title: 'Industry Registration Total (x1000) - Brazil',
          color: '#bdbdbd'
        },
        {
          key: 'ind_reg_tot',
          title: 'Industry Registration Total',
          color: '#bdbdbd'
        },
        {
          key: 'cli_ret_tot',
          title: `HMB Registration Total`,
          color: '#03a9f4'
        },
        {
          key: 'mkt_area',
          title: `HMB Market Share Total`,
          color: '#03a9f4'
        },
        {
          key: 'cli_ret_sal',
          title: `HMB Retail Sales`,
          color: '#03a9f4'
        }
      ];
    },

    doneAndForecastConfig() {
      return [
        {
          key: 'pais',
          title: 'Industry Registration Total (x1000) - Brazil',
          color: '#eee',
          auxColor: '#f5f5f5',
          bold: true
        },
        {
          key: 'ind_reg_tot',
          title: 'Industry Registration Total',
          color: '#eee',
          aux: 'A=B+C',
          auxColor: '#f5f5f5',
          bold: true
        },
        {
          key: 'ind_reg_ret',
          title: 'Industry Registration - Retail',
          color: '#eee',
          aux: 'B',
          auxColor: '#f5f5f5',
          bold: false
        },
        {
          key: 'ind_reg_drt',
          title: 'Industry Registration - Direct Sales',
          color: '#eee',
          aux: 'C',
          auxColor: '#f5f5f5',
          bold: false
        },
        {
          key: 'cli_ret_tot',
          title: `HMB Registration Total`,
          color: '#03a9f4',
          aux: 'D=E+F',
          auxColor: '#b3e5fc',
          bold: true
        },
        {
          key: 'cli_ret_ret',
          title: `HMB Registration - Retail`,
          color: '#03a9f4',
          aux: 'E',
          auxColor: '#b3e5fc',
          bold: false
        },
        {
          key: 'cli_ret_drt',
          title: `HMB Registration - Direct Sales`,
          color: '#03a9f4',
          aux: 'F',
          auxColor: '#b3e5fc',
          bold: false
        },
        {
          key: 'mkt_area',
          title: `HMB Market Share Total`,
          color: '#03a9f4',
          aux: 'G=D/A',
          auxColor: '#b3e5fc',
          bold: true
        },
        {
          key: 'ind_ret_sal',
          title: 'Industry Retail Sales',
          color: '#eee',
          aux: 'H',
          auxColor: '#f5f5f5',
          bold: true
        },
        {
          key: 'inv_exp',
          title: 'INVASION / EXPORT',
          color: '#eee',
          aux: 'I=H/B',
          auxColor: '#f5f5f5',
          bold: true
        },
        {
          key: 'cli_out',
          title: `HMB Outlets`,
          color: '#03a9f4',
          aux: 'J',
          auxColor: '#b3e5fc',
          bold: true
        },
        {
          key: 'cli_spd',
          title: `HMB SPD (Retail Sales Per Dealer)`,
          color: '#03a9f4',
          aux: 'K=D*I/J',
          auxColor: '#b3e5fc',
          bold: true
        },
        {
          key: 'cli_ret_sal',
          title: `HMB Retail Sales`,
          color: '#03a9f4',
          aux: 'L=K*J',
          auxColor: '#b3e5fc',
          bold: true
        }
      ];
    },

    industryBenchmarkingConfig() {
      return [
        {
          key: 'pos',
          title: 'POS (Point of Sales)',
          aux: 'A'
        },
        {
          key: 'total_registration',
          title: 'Total Registration',
          aux: 'B'
        },
        {
          key: 'market_share',
          title: 'Market-Share',
          aux: 'C'
        },
        {
          key: 'spd',
          title: 'SPD (Sales Per Dealer)',
          aux: 'D=B/A'
        },
        {
          key: 'dealer_grupo',
          title: 'Dealer Groups',
          aux: 'E'
        },
        {
          key: 'spg',
          title: 'SPG (Sales Per Group)',
          aux: 'F=B/E'
        }
      ];
    }
  },

  mixins: [httpMixin, i18nMixin, numeralMixin, momentMixin, stringMixin],

  methods: {
    createMap() {
      const HeatmapOverlay = require('heatmap.js/plugins/leaflet-heatmap/leaflet-heatmap.js');

      _.forEach(this.worldMaps, e => e.remove());

      const options = {
        center: new L.LatLng(this.mapCenter.lat, this.mapCenter.lng),
        zoom: 5,
        zoomControl: false,
        attributionControl: false
      };

      this.worldMaps = _.map(_.range(1, 4), i => {
        return L.map(this.$refs[`worldMapContainer${i}`], {
          ...options,
          // preferCanvas: true,
          zoomDelta: 0.5,
          zoomSnap: 0.5,
          zoom: i === 1 ? 18 : i === 2 ? 4 : 2.25,
          boxZoom: i === 1,
          doubleClickZoom: i === 1,
          dragging: i === 1,
          scrollWheelZoom: i === 1
        });
      });

      const mapLayers = _.map(_.range(0, 3), i => {
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution:
            i === 0
              ? '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
              : '',
          maxZoom: 19,
        }).addTo(this.worldMaps[i]);
      });

      const areaLayer = L.geoJSON(this.shapes.area, {
        style: () => ({
          fill: '#03a9f4',
          color: '#03a9f4',
          weight: 1
        })
      }).addTo(this.worldMaps[2]);

      const areaWithZoomLayer = L.geoJSON(this.shapes.area, {
        style: () => ({
          fill: '#03a9f4',
          color: '#03a9f4',
          weight: 2
        })
      }).addTo(this.worldMaps[1]);

      const mainWorldMap = this.worldMaps[0];
      mainWorldMap.fitBounds(areaWithZoomLayer.getBounds());
      this.worldMaps[1].fitBounds(areaWithZoomLayer.getBounds());

      // Configure stores
      // Initialize the SVG layer
      const svgLayer = L.svg();
      mainWorldMap.addLayer(svgLayer);
      // We simply pick up the SVG from the map object
      const g = d3.select(svgLayer._container).append('g');
      const svgLayerGroup = g
        .selectAll('image')
        .data(this.shapes.stores.features)
        .enter()
        .append('image')
        .attr(
          'xlink:href',
          f =>
            `${CONFIG.URL.NEOGIG_IMAGE}/pin_${_.deburr(f.properties.Bandeira)
              .toLowerCase()
              .replace(/(\ |-)/g, '_')}_sm.png`
        )
        .attr('width', () => 19)
        .attr('height', () => 24);

      const setSvgLayerPosition = () => {
        svgLayerGroup
          .attr('x', f => mainWorldMap.latLngToLayerPoint([f.geometry.coordinates[1], f.geometry.coordinates[0]]).x - 9)
          .attr(
            'y',
            f => mainWorldMap.latLngToLayerPoint([f.geometry.coordinates[1], f.geometry.coordinates[0]]).y - 24
          );
      };
      mainWorldMap.on('moveend', setSvgLayerPosition);
      setSvgLayerPosition();

      // Configure heat Layer
      const heatLayer = new HeatmapOverlay({
        radius: 20,
        blur: 0.6,
        minOpacity: 0.1,
        maxOpacity: 1,
        latField: 'y',
        lngField: 'x',
        valueField: 'z',
        gradient: {
          1: '#d53e4f',
          0.9: '#fdae61',
          0.7: '#abdda4',
          0.6: '#66c2a5',
          0.4: '#3288bd'
        }
      });

      const heatData = _.map(this.shapes.sales.features, f => ({
        y: f.geometry.coordinates[1], // Lat
        x: f.geometry.coordinates[0], // Lng
        z: f.properties.Total
      }));

      try {
        heatLayer.setData({
          max: _.maxBy(heatData, d => d.z).z,
          data: heatData
        });

        mainWorldMap.addLayer(heatLayer);
        this.disableLoading();
      } catch (e) {
        this.disableLoading();
      }
    },

    getChartIndustryColor(e) {
      return e.dataItem.tipo === 'ESTIMATE' ? '#eee' : '#bdbdbd';
    },

    getChartIndustryBorderColor(e) {
      return e.dataItem.tipo === 'ESTIMATE' ? '#bdbdbd' : '#757575';
    },

    getChartBrandColor(e) {
      return e.dataItem.tipo === 'ESTIMATE' ? '#81d4fa' : '#03a9f4';
    },

    getChartBrandBorderColor(e) {
      return e.dataItem.tipo === 'ESTIMATE' ? '#29b6f6' : '#0288d1';
    },

    getChartBorderType(e) {
      return e.dataItem.tipo === 'ESTIMATE' ? 'dash' : 'solid';
    },

    getChartBorderWidth(e) {
      return e.dataItem.tipo === 'ESTIMATE' ? 2 : 1;
    },

    getAreaTypeText(type) {
      switch (type) {
        case 3:
          return '';
        case 101:
          return 'CONTRACTUAL AREA';
        default:
          return 'OPERATIONAL AREA';
      }
    },

    getAreaTypeTextAlt(type) {
      switch (type) {
        case 3:
          return 'CITY';
        case 101:
          return 'CONTRACTUAL AREA';
        default:
          return 'OPERATIONAL AREA';
      }
    },

    requestData() {
      try {
        let bbox;

        if (_.some(this.ignoredAreas, id => this.dataQuery.location.value === id)) {
          this.reportData = {};
          return undefined;
        }

        this.enableLoading();
        const locationUrl = `${CONFIG.URL.NEOGIG_API}/localidade/ObterLocalidade/?id=${
          this.dataQuery.location.value
        }&idTipoLocalidade=${this.dataQuery.type.value}&agrupamento=false`;
        const reportDataUrl = `${CONFIG.URL.NEODASH_API}/api/gigdash/marketAnalysis/${
          this.dataQuery.location.value
        }/${this.dataQuery.market_share_reference.value}/${this.dataQuery.periodo.value}`;

        traceLogAccess.logAction(ContextEnum.Report, `Market Summary - filtro`, JSON.stringify(locationUrl, reportDataUrl));

        return Promise.all([this.http.get(locationUrl), this.http.get(reportDataUrl)])
          .then(res => {
            this.brand = res[1].data.brandName.toUpperCase() === 'HYUNDAI' ? 'HMB' : res[1].data.brandName;

            this.yearSelect = res[1].data.industryBenchmarking[0].ano_periodo;

            const reportData = {
              ...res[1].data,
              title: `${this.dataQuery.location.text.toUpperCase()} ${this.getAreaTypeText(this.dataQuery.type.value)}`
            };
            reportData.doneAndForecastTable = _.groupBy(reportData.doneAndForecast, d =>
              d.tipo === 'ESTIMATE' ? 1 : 0
            );
            this.reportData = reportData;

            this.shapes.area = topojson.feature(res[0].data, res[0].data.objects.output);

            const envelope = turf.envelope(this.shapes.area).geometry.coordinates[0];
            bbox = `LINESTRING(${envelope[0][0]} ${envelope[0][1]}, ${envelope[2][0]} ${envelope[2][1]})`;

            const data = {
              bandeiras: 'TOYOTA,ASTON MARTIN,AUDI,BENTLEY,BMW,BUGATTI,CADILLAC,CHANGAN,CHERY,CHRYSLER,CITROEN,DODGE,FERRARI,FIAT,FORD,GM,HMB,HONDA,HYUNDAI,INFINITI,JAC,JAGUAR,JEEP,KIA,LAMBORGHINI,LAND ROVER,LEXUS,LIFAN,LINCOLN,MASERATI,MERCEDES,MINI,MITSUBISHI,NISSAN,PEUGEOT,PORSCHE,RENAULT,ROLLS ROYCE,SSANGYONG,SUBARU,SUZUKI,TROLLER,VOLVO,VW',
              ano: this.moment().subtract(1, 'year').format('YYYY'),
              bbox: bbox
            }
            const storeSalesUrl = `${
              CONFIG.URL.NEOGIG_API
            }/lojaconcessionaria/obterdadosclustervendas`;
            return this.http.post(storeSalesUrl,data);
          })
          .then(res => {
            this.shapes.sales = res.data;

            const storesUrl = `${CONFIG.URL.NEOGIG_API}/lojaconcessionaria/GetStoreCompetitors`;
            return this.http.post(storesUrl, { bbox });
          })
          .then(res => {
            this.shapes.stores = topojson.feature(res.data, res.data.objects.output);
            this.createMap();
          });
      } catch (err) {
        console.log(err);
        this.reportData = {};
        this.disableLoading();
      }
    }
  },

  mounted() {
    this.requestData();
  },

  watch: {
    dataQuery() {
      if (this.dataQuery.showMarketSummary) {
        this.requestData();
      }
    }
  },

  components: {
    KendoChart,
    KendoGrid,
    ReportLegend,
    ReportUnavailable
  }
};
</script>

<style lang="scss" scoped>
.ui.tiny.header {
  font-size: 0.725rem;
  .sub.header {
    font-size: 0.725rem;
  }
}

.map {
  border-radius: 4px;
  border: 1px solid #ccc;
  height: 92%;
  width: 100%;
  position: relative;
}

.image {
  border-radius: 4px;
  border: 1px solid #ccc;
}

.ui.table {
  border-color: #ccc;
  /*font-size: 0.75rem;*/
}

.ui.segment {
  border-color: #ccc;
}

.map-1 {
  height: 100%;
  border: 1px solid #a1a1a1;
}

.map-2 {
  height: 50%;
  border-top: 1px solid #a1a1a1;
  border-right: 1px solid #a1a1a1;
  border-bottom: 1px solid #a1a1a1;
}

.map-3 {
  height: 50%;
  border-bottom: 1px solid #a1a1a1;
  border-right: 1px solid #a1a1a1;
}

span {
  display: block;
  font-size: 0.75rem;
}
</style>
